import React, { memo, useCallback } from 'react'

import {
  Icon,
  AIGenerated,
  ChevronRightDouble,
  ChevronLeftDouble,
  classnames,
} from '@cgtrader/triangle-ui/dist/src/ssr-index'

import { iconSizeMedium } from 'Pods/ThreeDStudio/constants'
import { useThreeDStudioStore } from 'Pods/ThreeDStudio/Store'
import { setIsModelSettingsOpen } from 'Pods/ThreeDStudio/Store/actions/ui'

function Header() {
  const isModelSettingsOpen = useThreeDStudioStore(state => state.ui?.isModelSettingsOpen)

  const handleClick = useCallback(() => {
    setIsModelSettingsOpen(!isModelSettingsOpen)
  }, [isModelSettingsOpen])

  return (
    <div
      className={classnames(
        'header__model-settings',
        isModelSettingsOpen && 'header__model-settings--opened'
      )}
      onClick={handleClick}
    >
      {isModelSettingsOpen && (
        <>
          <Icon svgComponent={AIGenerated} color="dark" size={iconSizeMedium} notSpaced />
          <span className="header__title">Generate 3D Model</span>
          <Icon
            svgComponent={ChevronLeftDouble}
            color="dark"
            size={iconSizeMedium}
            notSpaced
            className="header__model-settings-icon"
          />
        </>
      )}
      {!isModelSettingsOpen && <Icon svgComponent={ChevronRightDouble} color="dark" size={iconSizeMedium} notSpaced />}
    </div>
  )
}

export default memo(Header)
